import useRisksmartUser from '@risksmart-app/components/src/hooks/useRisksmartUser';
import type { AppetiteModel } from '@risksmart-app/domain/src/types/consts/appetite-model';
import { AppetiteModel as Appetite_Model_Enum } from '@risksmart-app/domain/src/types/consts/appetite-model';
import type { RiskScoringModel } from '@risksmart-app/domain/src/types/consts/risk-scoring-model';
import { RiskScoringModel as Risk_Scoring_Model_Enum } from '@risksmart-app/domain/src/types/consts/risk-scoring-model';
import { z } from 'zod';

import { useGetAggregationSettingsForOrg } from './queries';

type AggregationSettings = {
  loading: boolean;
  riskModel: RiskScoringModel;
  appetiteAggregation: AppetiteModel;
  enableTierTwoCascading: boolean;
};

const appetiteCascadingConfigSchema = z.object({
  enableTierTwoCascading: z.boolean().optional(),
});

export const getEnableTierTwoCascading = (config: unknown): boolean =>
  appetiteCascadingConfigSchema.safeParse(config).data
    ?.enableTierTwoCascading ?? false;

export const useAggregation = (): AggregationSettings => {
  const { isAuthenticated } = useRisksmartUser();

  const { data, loading } = useGetAggregationSettingsForOrg({
    queryArgs: {},
    shouldSkip: !isAuthenticated,
  });

  return {
    loading,
    riskModel:
      data?.aggregation_org?.[0]?.RiskScoringModel ??
      Risk_Scoring_Model_Enum.Default,
    appetiteAggregation:
      data?.aggregation_org?.[0]?.Appetite ?? Appetite_Model_Enum.Default,
    enableTierTwoCascading: getEnableTierTwoCascading(
      data?.aggregation_org?.[0]?.Config
    ),
  };
};
